import React from 'react';
import {SOURCE_TYPE} from '@packages/domains/billing/types';

import {AmexIcon} from './AmexIcon';
import {CashAppIcon} from './CashAppIcon';
import {CreditCardIcon} from './CreditCardIcon';
import {DiscoverCardIcon} from './DiscoverCardIcon';
import {JcbIcon} from './JcbIcon';
import {MastercardIcon} from './MastercardIcon';
import {UnionpayIcon} from './UnionpayIcon';
import {VisaIcon} from './VisaIcon';

const IconMap: Record<string, React.ReactNode> = {
  visa: <VisaIcon />,
  mastercard: <MastercardIcon />,
  discover: <DiscoverCardIcon />,
  amex: <AmexIcon />,
  unionpay: <UnionpayIcon />,
  jcb: <JcbIcon />,
  fallback: <CreditCardIcon />,
  cashapp: <CashAppIcon />,
};

interface Props {
  sourceType: string;
  brand: string | undefined | null;
}

/**
 * Convenient map for Stripe payment method types to icons.
 */
export const StripeSourceIcon = ({sourceType, brand}: Props) => {
  if (sourceType === SOURCE_TYPE.STRIPE_CARD) {
    return IconMap[brand as string] || IconMap.fallback;
  }
  if (sourceType === SOURCE_TYPE.STRIPE_CASH_APP) {
    return IconMap.cashapp;
  }
  return IconMap.fallback;
};
